import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getCountry = () => apiUtils.getCountry().toLowerCase();

const getCities = async () => {
    const uri = `/addresses/suggestion/cities?country=${getCountry()}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load cities (${response.status})`);
    }
    return response.json();
};

const getDistricts = async city => {
    const uri = `/addresses/suggestion/districts?country=${getCountry()}&city=${city}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load districts of city ${city} (${response.status})`);
    }
    return response.json();
};

const getNeighborhoods = async (city, district) => {
    const uri = `/addresses/suggestion/neighborhoods?country=${getCountry()}&city=${city}&district=${district}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load neighborhood of city ${city} (${response.status})`);
    }
    return response.json();
};

export default {
    getCities,
    getDistricts,
    getNeighborhoods,
};
